<template>
  <vis-splash-screen v-if="!loaded" @loaded="onLoaded"></vis-splash-screen>
  <router-view v-else></router-view>
</template>

<script>
import VisSplashScreen from "./views/vis-splash-screen";

export default {
  name: "app",
  components: {
    VisSplashScreen
  },
  data() {
    return {
      loaded: false
    };
  },
  methods: {
    onLoaded() {
      this.loaded = true;
    }
  }
};
</script>

<style lang="scss">
@import "assets/scss/vendor";
@import "assets/scss/style";
</style>
